<template>
  <div>
    <div class="title">
      <h3 class="left">Edition des adresses</h3>
    </div>

    <div class="col-sm-12">
      <form class="form-horizontal" role="form">

        <div class="form-group">
          <h5>Adresse principale : </h5>
          <label for="main_street" class="col-sm-3 control-label">Adresse</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="main_street" placeholder="2 rue de Gimenez ..."
                   name="main_street">
          </div>
          <label for="main_postal_code" class="col-sm-3 control-label">Code postal</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="main_postal_code" placeholder="75015 ..."
                   name="main_postal_code">
          </div>
          <label for="main_city" class="col-sm-3 control-label">Ville</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="main_city" placeholder="Paris ..."
                   name="main_city">
          </div>
        </div>

        <div class="form-group">
          <h5>Adresse de facturation : </h5>
          <label for="billing_street" class="col-sm-3 control-label">Adresse</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="billing_street" placeholder="2 rue de Gimenez ..."
                   name="billing_street">
          </div>
          <label for="billing_postal_code" class="col-sm-3 control-label">Code postal</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="billing_postal_code" placeholder="75015 ..."
                   name="billing_postal_code">
          </div>
          <label for="billing_city" class="col-sm-3 control-label">Ville</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="billing_city" placeholder="Paris ..."
                   name="billing_city">
          </div>
        </div>

        <div class="form-group">
          <h5>Adresse de comptabilité : </h5>
          <label for="accounting_street" class="col-sm-3 control-label">Adresse</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="accounting_street" placeholder="2 rue de Gimenez ..."
                   name="accounting_street">
          </div>
          <label for="accounting_postal_code" class="col-sm-3 control-label">Code postal</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="accounting_postal_code" placeholder="75015 ..."
                   name="accounting_postal_code">
          </div>
          <label for="accounting_city" class="col-sm-3 control-label">Ville</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="accounting_city" placeholder="Paris ..."
                   name="accounting_city">
          </div>

          <button class="btn btn-sm pull-right btn-success m-t-20 m-r-15">Valider</button>
          <button class="btn btn-sm pull-right btn-white m-t-20 m-r-15" @click.prevent="goBack">Annuler</button>
        </div>
    </form>
  </div>
  </div>
</template>

<style lang="scss" scoped>
  .col-sm-9, .col-sm-3 {
    margin-top: 15px;
  }
</style>

<script type="text/babel">
  import customerMixin from 'mixins/customer'
  import {mapActions} from 'vuex'

  export default {

    name: 'EditAddresses',

    mounted () {
      $('.dropdown-select').select2({
        minimumResultsForSearch: -1
      })
    },

    methods: {
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Edit/Customer/InformationsContent/EditAddresses.vue